import { CommonModule } from '@angular/common';

import { ChangeDetectionStrategy, Component,Input,OnChanges } from '@angular/core';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject } from 'rxjs';

import { MathScope } from 'mathjs';
import * as mjsHelper from '../../helper/math-js-helper';







@Component({
    selector: 'app-calculation-input-result',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatLegacyFormFieldModule],
    templateUrl: './calculation-input-result.component.html',
    styleUrls: ['./calculation-input-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalculationInputResultComponent implements OnChanges {
    protected result$ = new BehaviorSubject<number | null>(null);
    protected formulaInvalid$ = new BehaviorSubject<boolean>(false);
    @Input() formula: string;
    @Input() maxDecimalPlaces: number | null;
    @Input() mathScope: MathScope;


    ngOnChanges(): void {
        const r = mjsHelper.evaluate(this.formula, this.maxDecimalPlaces, this.mathScope);
        if (r.invalid !== this.formulaInvalid$.value) {
            this.formulaInvalid$.next(r.invalid);
        }
        if (r.res !== this.result$.value) {
            this.result$.next(r.res);
        }
    }
}
